import script from "./InvoiceSection8.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSection8.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSection8.vue?vue&type=style&index=0&id=7efacdfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7efacdfc"]])

export default __exports__